<template>
    <div>
        <public-menu></public-menu>
        <public-help-huodaofukuan></public-help-huodaofukuan>
        <bottom-nav></bottom-nav>
        <public-footer></public-footer>
    </div>
</template>

<script>
import Public_menu from "@/components/common/public-top"
import Public_help_huodaofukuan from "@/components/help/huodaofukuan"
import Bottom_nav from "@/components/common/bottom-nav"
import Footer from "../../components/Footer.vue"
export default {
    components:{
        'public-menu': Public_menu,
        'public-help-huodaofukuan': Public_help_huodaofukuan,
        'bottom-nav': Bottom_nav,
        'public-footer': Footer
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');

</style>


// WEBPACK FOOTER //
// src/views/help/huodaofukuan.vue